import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { TableContextProvider } from './context';
export var TableContainer = function (props) {
    var classNames = namespacedClassnames('table');
    return (React.createElement("div", { className: classNames + (props.className ? " " + props.className : '') }, props.children));
};
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Table.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('table-contents', { 'is-empty': !!props.isEmpty }, props.className, props.shortRows ? 'short-rows' : '');
        return (React.createElement(TableContextProvider, { colWidths: props.colWidths },
            React.createElement("div", { className: classNames }, props.children)));
    };
    return Table;
}(React.PureComponent));
export { Table };
//# sourceMappingURL=table.js.map